import { restRequest } from "vrcore-dashboard/dist/utilities";


export const GET_QUALIFICATION_ALERTS = restRequest(
    "VRCORE.ALERTS_WIDGETS.QUALIFICATION_ALERT_WIDGET.GET_QUALIFICATION_ALERTS"
);
export const GET_USERS = restRequest(
    "VRCORE.ALERTS_WIDGETS.QUALIFICATION_ALERT_WIDGET.GET_USERS"
);
export const REMOVE_QUAL_ALERT = restRequest(
    "VRCORE.ALERTS_WIDGETS.QUALIFICATION_ALERT_WIDGET.REMOVE_QUAL_ALERT"
);

